import { insert, without } from 'ramda'

import {
  MultiOptionItem,
  MultiOptionList
} from '@/components/multi-option-select'

import { handleDataLayerEvent } from './utils'

const BedRadioBar = ({ t, bedroom_count = [], updateFilters, disabled }) => {
  const handleUpdateFilters = id => {
    handleDataLayerEvent('bed')
    const count = bedroom_count || []
    const filter = count?.includes(id)
      ? without(id, count)
      : insert(0, id, count)
    const sortedFilter = filter.sort((a, b) => {
      return (
        /[A-Za-z]/.test(b) - /[A-Za-z]/.test(a) ||
        a.charCodeAt(0) - b.charCodeAt(0)
      )
    })
    return updateFilters({ bedroom_count: sortedFilter })
  }

  const OPTIONS = [
    {
      id: '0',
      label: t('filters:b.listing_filter.edit.bedroom_0_studio.text', 'Studio'),
      clickId: 'studio'
    },
    {
      id: '1',
      label: '1',
      clickId: '1'
    },
    {
      id: '2',
      label: '2',
      clickId: '2'
    },
    {
      id: '3',
      label: '3',
      clickId: '3'
    },
    {
      id: '4+',
      label: '4+',
      clickId: '4+'
    }
  ]

  return (
    <MultiOptionList disabled={disabled}>
      {OPTIONS.map(option => (
        <MultiOptionItem
          key={option.id}
          id={option.id}
          clickId={`search-filter-bed-${option.clickId}`}
          label={option.label}
          onClick={handleUpdateFilters}
          selected={bedroom_count?.includes(option.id) || false}
        />
      ))}
    </MultiOptionList>
  )
}

export default BedRadioBar
